import { ChevronRight } from '@ixigo/icons';
import ListItem from '@ixigo/iui/ListItem';
import ListItemIcon from '@ixigo/iui/ListItemIcon';
import ListItemText from '@ixigo/iui/ListItemText';
import Typography from '@ixigo/iui/Typography';
import { FC, createElement } from 'react';
import more from '../../images/productMore.svg';
import { MORE_MENU_ITEMS } from './helper';

const MoreMenu: FC = () => {
    const onItemClick = (getDynamicUrl: () => string) => {
        const url = getDynamicUrl();
        if (url) {
            window.open(url, '_blank');
        }
    };

    return (
        <div className='group relative flex items-center gap-5 cursor-pointer'>
            <img src={more} alt='More' width={40} height={40} />
            <Typography variant='body-md' fontWeight='bold' className='text-charcoal-600'>
                More
            </Typography>
            <ChevronRight className='rotate-90 transition-transform group-hover:-rotate-90' />
            <ul className='hidden absolute top-full left-0 w-[300px] py-10 bg-white rounded-20 overflow-hidden shadow-500 group-hover:block'>
                {MORE_MENU_ITEMS.map((item) => {
                    const linkItem = (
                        <ListItem className='h-11 cursor-pointer'>
                            <ListItemIcon type='avatar' className='items-center'>
                                {createElement(item.icon, { className: 'text-charcoal-600' })}
                            </ListItemIcon>
                            <ListItemText primary={item.title} />
                        </ListItem>
                    );

                    return item?.dynamicUrl ? (
                        <div onClick={() => onItemClick(item?.dynamicUrl)} key={item.title}>
                            {linkItem}
                        </div>
                    ) : (
                        <a
                            href={item.href}
                            key={item.title}
                            className='cursor-pointer'
                            target='_blank'
                            rel='noreferrer'
                        >
                            {linkItem}
                        </a>
                    );
                })}
            </ul>
        </div>
    );
};

export default MoreMenu;
